<template>
  <v-container
    class="justify-center"
    container--fluid
    fill-height
    style="background: #e6e6fc;"
  >
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6" md="6" lg="5" xl="5">
        <v-stepper
          v-model="st"
          class="ra-2"
          style="
                    border-top: 5px solid #7f79d9;
                    border-bottom: 5px solid #7f79d9;
                    box-shadow: 0px 0px 27px 5px rgba(2, 2, 2, 0.096) ;
              "
        >
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card flat text class="pa-5 elevation-0">
                <div class>
                  <v-img
                    height="60"
                    contain
                    src="https://cdn.siap.id/s3/masook/asset img/SIM/logo.png"
                    aspect-ratio="1"
                  ></v-img>
                </div>
                <v-card-title primary-title class="justify-space-around">
                  <span
                    class="title primary--text d-block text-center font-weight-bold"
                    >AKTIVASI AKUN PENGGUNA</span
                  >
                </v-card-title>
                <v-card-text>
                  <v-form data-vv-scope="form-aktivasi" lazy-validation>
                    <v-row column wrap>
                      <v-col cols="12" class="text-center">
                        <img
                          src="https://cdn.siap.id/s3/masook/asset%20img/SIM/aktv-pengguna.png"
                          style="width: 50%"
                        />
                        <p
                          class="justify-space-around black--text caption mb-0"
                        >
                          Silakan melakukan aktivasi <b>akun pengguna</b> dengan
                          memasukkan <b>kode token</b> yang telah Anda dapat
                          dari instansi Anda. Atau hubungi Admin / Operator
                          instansi Anda untuk informasi lebih lanjut.
                        </p>
                      </v-col>
                      <v-col cols="12" class="pb-0">
                        <span>Kode Token</span>
                        <v-text-field
                          label="Kode Token"
                          v-model="token"
                          hint="Silakan masukkan kode token Anda*"
                          outlined
                          dense
                          single-line
                          data-vv-name="token"
                          data-vv-as="Kode Token"
                          v-validate="'required'"
                          :error-messages="
                            errors.collect('form-aktivasi.token')
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="justify-space-around text-center">
                        <v-btn
                          :loading="loading"
                          depressed
                          large
                          block
                          color="primary"
                          @click="aktivasi"
                          >AKTIFKAN</v-btn
                        >
                        <router-link class="ok" :to="{ name: 'login' }">
                          <p class="mt-4">Kembali ke halaman Login</p>
                        </router-link>
                      </v-col>
                      <br />
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card text class="pa-5">
                <div class>
                  <v-img
                    height="60"
                    contain
                    src="https://cdn.siap.id/s3/masook/asset img/SIM/logo.png"
                    aspect-ratio="1"
                  ></v-img>
                </div>
                <v-card-title primary-title class="justify-space-around">
                  <span
                    class="title primary--text d-block text-center font-weight-bold"
                    >Lengkapi Data Akun Anda</span
                  >
                </v-card-title>
                <v-card-text>
                  <v-form
                    @submit.prevent
                    data-vv-scope="form-sandi"
                    lazy-validation
                  >
                    <v-row align="center" justify="center">
                      <v-col cols="12" class="text-center">
                        <img
                          src="https://cdn.siap.id/s3/masook/asset%20img/SIM/aktv-pengguna2.png"
                          width="50%"
                        />
                        <p
                          class="justify-space-around black--text caption mb-5"
                        >
                          Silakan memasukkan <b>Username</b> dan
                          <b>Kata Sandi</b> untuk selanjutnya dapat Anda gunakan
                          login
                        </p>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                        <span>Username*</span>
                        <v-text-field
                          outlined
                          autofocus
                          dense
                          v-model="username"
                          placeholder="Masukkan username"
                          hint="Masukkan Username"
                          data-vv-name="nama"
                          data-vv-as="Username"
                          v-validate="'required'"
                          :error-messages="
                            errors.collect('form-sandi.username')
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                        <span>Kata Sandi*</span>
                        <v-text-field
                          ref="password"
                          outlined
                          dense
                          :append-icon="appendIcon"
                          @click:append="switchVisibility"
                          :type="passwordFieldType"
                          placeholder="Masukkan kata sandi"
                          v-model="password"
                          hint="Masukkan Kata Sandi"
                          data-vv-name="password"
                          data-vv-as="Kata Sandi"
                          v-validate="'required|min:6'"
                          :error-messages="
                            errors.collect('form-sandi.password')
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                        xl="12"
                        class="py-0"
                      >
                        <span>Konfirmasi Kata Sandi*</span>
                        <v-text-field
                          outlined
                          dense
                          :append-icon="appendIcon"
                          @click:append="switchVisibility"
                          :type="passwordFieldType"
                          v-model="password_confirmation"
                          hint="Konfirmasi Kata Sandi"
                          placeholder="Masukkan kata sandi"
                          data-vv-name="password_confirmation"
                          data-vv-as="Konfirmasi Kata Sandi"
                          v-validate="'required|min:6|confirmed:password'"
                          :error-messages="
                            errors.collect('form-sandi.password_confirmation')
                          "
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    class="mr-auto ml-auto"
                    width="50%"
                    :loading="loading"
                    depressed
                    color="primary"
                    @click="setPassword"
                    >Simpan</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-dialog persistent v-model="dialog" width="550">
                <v-card
                  text
                  class="pa-5"
                  style="
                    border-top: 5px solid #7f79d9;
                    border-bottom: 5px solid #7f79d9;
              "
                >
                  <div class>
                    <v-img
                      height="60"
                      contain
                      src="https://cdn.siap.id/s3/masook/asset img/SIM/logo.png"
                      aspect-ratio="1"
                    ></v-img>
                  </div>
                  <v-card-title primary-title class="justify-space-around">
                    <span
                      class="title primary--text d-block text-center font-weight-bold"
                      >Berhasil</span
                    >
                  </v-card-title>
                  <v-card-text class="black--text text-center">
                    <div>
                      <img
                        src="https://cdn.siap.id/s3/masook/asset%20img/SIM/ak-user.png"
                        style="width: 30%"
                      />
                      <p class="mt-4 pt-4 caption">
                        Proses aktivasi akun instansi layanan Masook Anda
                        berhasil. Silakan login dengan akun yang telah Anda
                        buat.
                      </p>
                      <p />
                      <p>Terima kasih</p>
                      <router-link class="ok" :to="{ name: 'login' }">
                        <p class="mt-4">Kembali ke halaman Login</p>
                      </router-link>
                    </div>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
export default {
  components: { VueRecaptcha },
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      st: 1,
      dialog: false,
      user: null,
      appendIcon: "mdi-eye-off",
      passwordFieldType: "password",
      token: "",
      username: null,
      password: null,
      password_confirmation: null,
      loading: false,
      is_sso: 0
    };
  },
  activated() {
    this.user = null;
    this.dialog = false;
    this.is_sso = false;
  },
  mounted() {
    this.checkQuery();
  },
  methods: {
    checkQuery() {
      if (this.$route.query.token) {
        this.token = this.$route.query.token;
        // clean query
        // langsung lakukan verifikasi
        this.$nextTick(() => {
          this.aktivasi();
        });
      } else {
        this.dlgSelector = true;
      }
    },
    // eslint-disable-next-line
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      this.passwordFieldType === "password"
        ? (this.appendIcon = "mdi-eye-off")
        : (this.appendIcon = "mdi-eye");
    },
    toLogin() {
      this.dialog = false;
      this.$router.push({
        name: "login"
      });
    },
    aktivasi() {
      this.$validator
        .validateAll("form-aktivasi")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store
            .dispatch("user/aktivasiUser", {
              token: this.token
            })
            .then(res => {
              this.user = res.data;
              if (!res.data.username) {
                this.st = 2;
              } else {
                this.username = res.data.username.username;
                this.st = 2;
              }
              return res;
            })
            .catch(e => e);
        })
        .catch(e => e);
    },
    setPassword() {
      this.$validator
        .validateAll("form-sandi")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store
            .dispatch("user/setAkun", {
              username: this.username,
              password: this.password,
              password_confirm: this.password_confirmation,
              token: this.token
            })
            .then(res => {
              if (res.code !== 200) {
                this.$error("Proses pembaruan akun gagal");
              } else {
                this.st = 3;
                this.dialog = true;
                return res;
              }
            })
            .catch(error => {
              this.$error(
                [416, 520].includes(Number(error.response.data.code))
                  ? error.response.data.message
                  : "Terjadi kesalahan pada sistem. Hubungi Administrator."
              );
            });
        })

        .catch(e => e);
    },
    toAktivasi() {
      this.$router.replace({ name: "user.aktivasi" });
    }
  }
};
</script>
